import { render, staticRenderFns } from "./GangaoRecruitstudents.vue?vue&type=template&id=0fdb8f3a&scoped=true"
import script from "./GangaoRecruitstudents.vue?vue&type=script&lang=js"
export * from "./GangaoRecruitstudents.vue?vue&type=script&lang=js"
import style0 from "./GangaoRecruitstudents.vue?vue&type=style&index=0&id=0fdb8f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb8f3a",
  null
  
)

export default component.exports